<template>
  <div
    ref="rootEl"
    role="button"
    :tabindex="isDisabled ? -1 : 0"
    :aria-disabled="isDisabled || undefined"
    class="cursor-pointer"
    @click="onClick"
    @keydown="onKeydown"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "CustomSimpleButton",
  props: { isDisabled: { type: Boolean, default: false } },
  emits: ["onClick"],
  setup(props, { emit }) {
    const rootEl = ref<HTMLElement | null>(null);

    function onKeydown(event: KeyboardEvent): void {
      if (props.isDisabled || (event.key !== "Enter" && event.key !== " ")) {
        return;
      }
      event.preventDefault();
      rootEl.value?.click();
    }

    function onClick(event: MouseEvent): void {
      if (props.isDisabled) {
        return;
      }
      emit("onClick", event);
    }

    return { rootEl, onClick, onKeydown };
  },
});
</script>
